import styled from '@emotion/styled'
import { colorGrayscaleDark1 } from '@lib/colors'
import { mediaQueries } from '@lib/mediaQueries'

export const FieldLabel = styled.label({
  color: colorGrayscaleDark1,
  display: 'block',
  fontSize: '.875rem',
  fontWeight: 400,
  marginBottom: '.25rem',
})

interface FormGroupPropsI {
  count?: number
}
export const FormGroup = styled.div<FormGroupPropsI>(({ count = 1 }) =>
  mediaQueries({
    width:
      count > 1
        ? [
            '100%',
            '100%',
            `calc((100%/${count}) - (1rem * ${count - 1}))`,
            `calc((100%/${count}) - (1rem * ${count - 1}))`,
            `calc((100%/${count}) - (1rem * ${count - 1}))`,
          ]
        : '100%',
    '&:not(:first-of-type)': {
      marginTop: ['2rem', '2rem', 0, 0, 0],
    },
  })
)

export const FormRow = styled.div(
  mediaQueries({
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'nowrap', 'nowrap', 'nowrap'],
    justifyContent: 'space-between',
    width: '100%',
    '&:not(:first-of-type)': {
      marginTop: '2rem',
    },
  })
)
